<template>
<!-- 辞书世界 - 轮播图管理 -->
  <div class="container">
    <div class="operation-condition">
      <div>
        <label style="margin-right: 8px;font-size:14px" for>学会活动:</label>
        <el-select v-model="selectModuleValue" placeholder="全部" @change="handleSocietyActivityList">
          <el-option
          v-for="(item,index) in activityList"
          :key="index"
          :label="item.label"
          :value="item.id"/>
        </el-select>
      </div>
      <div>
        <el-input
          placeholder="请输入活动名称"
          v-model.trim="searchInfo"
          style="min-width: 300px;"
        >
          <el-button type="primary" slot="append" @click="searchHandler"
            >搜索</el-button
          >
        </el-input>
      </div>
      <div style="float: right;">
        <el-button v-on:click="addActivity" type="primary" style="width: 80px"
          >新建</el-button
        >
        <el-button
          type="danger"
          style="width: 80px"
          v-bind:disabled="delDisable"
          v-on:click="delClick"
          >删除</el-button
        >
      </div>
    </div>
    <div class="table_div">
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
        border
        style="width: 100%"

        :header-cell-style="{ background: '#eef1f6' }"
        >
        <el-table-column align="center" type="selection" width="55"/>
        <el-table-column
          type="index"
          label="序号"
          align="center"
          width="60">
        </el-table-column>
        <el-table-column
          prop="id"
          label="活动ID"
          align="center"
          width="100"
          >
        </el-table-column>
        <el-table-column
          prop="module"
          label="活动分类"
          align="center"

          >
          <template slot-scope="scope">
            <span>{{ getActivityType(scope.row.module)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="title"
          label="活动名称"
          align="center"
          >
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          align="center"
          width="160"
          :formatter="formatter"
          >
        </el-table-column>

        <el-table-column
          prop="status"
          width="120"
          align="center"
          label="状态">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status=='0'" type="success">发布中</el-tag>
            <el-tag v-else-if="scope.row.status=='1'" type="info">保 存</el-tag>
            <el-tag v-else-if="scope.row.status=='2'" type="primary">预发布</el-tag>
            <el-tag v-else type="warning">下 架</el-tag>
          </template>
        </el-table-column>

        <el-table-column
          prop="sort"
          label="置顶顺序"
          align="center"

          >
        </el-table-column>
        <el-table-column
          prop="createBy"
          label="创建人"
          align="center"
          >
        </el-table-column>

        <el-table-column
          prop="operate"
          width="280"
          align="center"
          :key="Math.random()"
          label="操作">

          <template slot-scope="scope" >

             <el-tooltip class="item" effect="light" v-if="scope.row.status=='0'||scope.row.status=='2'"  content="复制链接" placement="bottom">
               <!-- 链接 (发布中, 预发布 ) -->
              <i class="el-icon-link"  @click="handleCopyLink(scope.$index, scope.row)"></i>
               </el-tooltip>
              <!-- 预发布 (保存,下架) -->
            <el-tooltip class="item" effect="light" v-else-if="scope.row.status=='1'||scope.row.status=='3'" content="预发布" placement="bottom">
            <i class="el-icon-s-promotion" @click="handlePreannouncement(scope.row)"></i>
             </el-tooltip>

            <!-- 发布上线 (保存,预发布,下架状态)-->
            <el-tooltip class="item" effect="light" v-if=" isManage &&(scope.row.status=='1'||scope.row.status=='2'||scope.row.status=='3')" v-hasPermi="['function:news:release']" content="上线" placement="bottom">
            <i class="iconfont el-icon-mydownloadshangxian1"
            @click="handleReleaseOnline(scope.row.id)"></i>
             </el-tooltip>
            <!-- 下线 (已发布状态)-->
            <el-tooltip class="item" effect="light" v-if="isManage &&scope.row.status=='0'" v-hasPermi="['function:news:release']" content="下线" placement="bottom">
            <i class="iconfont el-icon-mydownloadxiaxian"   @click="handleTakeDown(scope.row.id)"></i>
             </el-tooltip>

            <el-tooltip class="item" effect="light"  content="预览" placement="bottom" >
              <i class="el-icon-view" @click="handleClickView(scope.row)" ></i>
             </el-tooltip>
            <!-- 编辑 -->
            <i class="el-icon-edit" @click="handleEditClick(scope.row)"></i>
            <!-- 删除 -->
            <i class="el-icon-delete" @click="handleDeleteClick(scope.row)"></i>
            <!-- 置顶 -->
            <i class="iconfont el-icon-mydownloadshuyi_zhiding" @click="handleToTop(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="pagenation.page_num"
          :page-size="pagenation.page_size"
          background
          layout="total, prev, pager, next"
          :total="pagenation.total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import SocietyActivityApi from '@/api/societyActivity/index.js'
import { mapRequestActions } from '@/utils'
import { MessageBox } from 'element-ui'
import { checkRole, getUserInfo } from '../../utils/auth'
import { getMyDate } from '@/utils/timeUtils.js'
export default {
  data () {
    return {
      loading: false,
      previewForm: {},
      selectModuleValue: '',
      isManage: false, // 是否是管理用户
      isRealCreater: '', // 是否自己是创建者
      enCryTime: '', // 加密后的时间字符串
      optionStatus: '',
      searchInfo: '',
      options: [],
      needPerson: false,
      copyData: null, // 复制链接
      activityList: [ // 活动列表
        { id: '', label: '全部' },
        { id: 1, label: '学会简介' },
        { id: 2, label: '学会章程' },
        { id: 3, label: '学会资讯' },
        { id: 4, label: '会议通知' },
        { id: 5, label: '学术研讨' },
        { id: 6, label: '专题活动' },
        { id: 7, label: '辞书出版' },
        { id: 8, label: '辞书获奖' },
        { id: 9, label: '辞书展览' },
        { id: 15, label: '学员文集' },
        { id: 11, label: '党建活动' }
      ],
      selectArr: [],
      delDisable: true,
      tableData: [],
      pagenation: {
        page_num: 1,
        page_size: 10,
        total: 0
      }
    }
  },
  created () {
    this.handleSocietyActivityList()
    /**
     * 检测用户权限
     */
    this.isManage = checkRole(['manage'])
    const res = getUserInfo()
    this.isRealCreater = res.username || ''
  },
  methods: {
    ...mapRequestActions(SocietyActivityApi),

    /**
     * 获取学会活动列表
     */
    handleSocietyActivityList () {
      this.societyActivityListAction({
        author: '',
        title: this.searchInfo,
        module: this.selectModuleValue,
        pageNum: this.pagenation.page_num,
        pageSize: this.pagenation.page_size
      }).then(res => {
        if (res.status) {
          this.pagenation = Object.assign({}, this.pagenation, {
            currentPage: 1,
            total: res.result.total
          })
          this.tableData = res.result.rows || []
        }
      })
    },

    /**
     * 分页
     */
    handleCurrentChange (newPage) {
      this.pagenation = Object.assign({}, this.pagenation, { newPage })
      this.handleSocietyActivityList()
    },

    searchHandler () {
      this.handleSocietyActivityList()
    },
    /**
     * 预览
     */
    handleClickView (item) {
      this.$router.push({ path: '/society-activity-edit', query: { id: item.id, module: item.module, isView: true } })
    },
    /**
     * 预发布
     */
    async handlePreannouncement (item) {
      if (!this.isManage && (this.isRealCreater !== item.createBy)) {
        this.$message.error('您只能预发布自己创建的活动')
      } else {
        this.loading = true
        const resp = await this.queryDetailByIdAction({
          id: item.id,
          module: item.module
        })
        if (resp.status) {
          const newArr = Object.assign(resp.result, { status: '2' })
          await this.upDateSocietyActivityAction({ ...newArr }).then(resp => {
            if (resp.status) {
              this.$message.success('预发布成功')
              this.handleSocietyActivityList()
            } else {
              this.$message.error(resp.errorMsg)
            }
            this.loading = false
          })
        }
      }
    },

    // handlePreannouncement (item) {
    //   this.loading = true
    //   // remark: 'not' 是否删除
    //   this.upDateSocietyActivityAction({ id: item.id, status: '2', remark: 'not' }).then(resp => {
    //     if (resp.status) {
    //       this.$message.success('预发布成功')
    //       this.handleSocietyActivityList()
    //     } else {
    //       this.$message.error(resp.errorMsg)
    //     }
    //     this.loading = false
    //   })
    //   // }
    // },
    /**
     * 发布上线
     */
    async handleReleaseOnline (id) {
      const resp = await this.releaseOnLineAction({ longId: id })
      if (resp.status) {
        this.$message.success('发布上线成功')
        this.handleSocietyActivityList()
      } else {
        this.$message.error(resp.errorMsg)
      }
    },
    /**
     * 下架
     */
    async handleTakeDown (id) {
      const resp = await this.takeDownAction({ longId: id })
      if (resp.status) {
        this.$message.success('下线成功')
        this.handleSocietyActivityList()
      } else {
        this.$message.error(resp.errorMsg)
      }
    },
    /**
     * 点击复制链接
     */
    handleCopyLink (index, row) {
      this.copyData = row.linkUrl || ''
      this.copy(this.copyData)
    },
    copy (data) {
      const url = data
      const oInput = document.createElement('input')
      oInput.value = url
      document.body.appendChild(oInput)
      oInput.select() // 选择对象;
      document.execCommand('Copy') // 执行浏览器复制命令
      this.$message({
        message: '复制成功',
        type: 'success'
      })
      oInput.remove()
    },
    /**
     * 置顶一条信息
     */
    async handleToTop (item) {
      const resultData = await this.setToTopAction({ module: item.module, id: item.id })
      if (resultData.status) {
        this.$message.success('置顶成功')
        this.handleSocietyActivityList()
      }
    },
    formatter (row, column, cellValue) {
      if (row) { return getMyDate(row.createTime) }
    },

    // selected items change
    handleSelectionChange (arr) {
      this.selectArr = arr
      if (arr.length !== 0) {
        this.delDisable = false
      } else {
        this.delDisable = true
      }
    },
    /**
     * 新增
     */
    addActivity () {
      this.$router.push('/society-activity-add')
    },
    /**
     * 编辑
     */
    handleEditClick (item) {
      // 条件1 不是管理者, 且自己账号 和 创建人信息不符合
      if (!this.isManage && (this.isRealCreater !== item.createBy)) {
        this.$message.error('您只能修改自己创建的活动')
      } else {
        this.$router.push({
          path: '/society-activity-edit', query: { id: item.id, module: item.module }
        })
      }
    },
    /**
     * 活动分类状态
     */
    getActivityType (type) {
      switch (type) {
        case '1' :
          return '学会简介'
        case '2' :
          return '学会章程'
        case '3' :
          return '学会资讯'
        case '4' :
          return '会议通知'
        case '5' :
          return '学术研讨'
        case '6' :
          return '专题活动'
        case '7' :
          return '辞书出版'
        case '8' :
          return '辞书获奖'
        case '9' :
          return '辞书展览'
        case '11' :
          return '党建活动'
        case '15' :
          return '学员文集'
      }
    },
    /**
     * 删除 全选操作
     */
    delClick () {
      const createrArray = this.selectArr.map(item => item.createBy)
      const isAllSame = this.isAllEqual(createrArray)
      // 1->不是管理则  2 多选数组中的创建者不一致  或者  创建者的数组不包含当前登录人员
      if (!this.isManage && (isAllSame === false || (!createrArray.includes(this.isRealCreater)))) {
        this.$message.error('您只能删除自己创建的活动')
      } else {
        const _this = this
        MessageBox.confirm("此操作将永久删除该活动（各栏目下的此活动将全部被删除）， 是否继续？ 如仅需删除当前栏目下的此活动，请到活动编辑页'显示位置'进行操作。", '提示').then(() => {
          const longIds = _this.selectArr.map(item => item.id)
          this.deleteNewsByIdAction({ longIds }).then(res => {
            if (res.status) {
              _this.$message({
                type: 'success',
                message: '删除成功'
              })
              _this.handleSocietyActivityList()
            } else {
              _this.$message.error(res.errorMsg || '删除失败')
            }
          })
        })
      }
    },
    /**
     * 删除 单选操作
     */
    handleDeleteClick (item) {
      if (!this.isManage && (this.isRealCreater !== item.createBy)) {
        this.$message.error('您只能删除自己创建的活动')
      } else {
        const _this = this
        MessageBox.confirm("此操作将永久删除该活动（各栏目下的此活动将全部被删除）， 是否继续？ 如仅需删除当前栏目下的此活动，请到活动编辑页'显示位置'进行操作。", '提示').then(() => {
          const longIds = [item.id]
          this.deleteNewsByIdAction({ longIds }).then(res => {
            if (res.status) {
              _this.$message.success('删除成功')
              _this.handleSocietyActivityList()
            } else {
              _this.$message.error(res.errorMsg || '删除失败')
            }
          })
        })
      }
    },

    /**
     * 判断数据组是否是相同的数据
     * 检测多选删除
     */
    isAllEqual (array) {
      if (array.length > 0) {
        return !array.some(function (value, index) {
          return value !== array[0]
        })
      } else {
        return true
      }
    }
    // 将毫秒值转为时间年/月/日
    // getMyDate (str) {
    //   var oDate = new Date(str)
    //   var oYear = oDate.getFullYear()
    //   var oMonth = oDate.getMonth() + 1
    //   var oDay = oDate.getDate()
    //   var oHour = oDate.getHours()
    //   var oMin = oDate.getMinutes()
    //   var oSen = oDate.getSeconds()
    //   var oTime = oYear + '-' + this.addZero(oMonth) + '-' + this.addZero(oDay) + ' ' + this.addZero(oHour) + ':' + this.addZero(oMin) + ':' + this.addZero(oSen)
    //   return oTime
    // },
    // // 补零操作
    // addZero (num) {
    //   if (parseInt(num) < 10) {
    //     num = '0' + num
    //   }
    //   return num
    // }

  }

}
</script>

<style lang='less' scoped>
@import "./index.less";
</style>
